import rawI18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import fr from './fr.json';
import de from './de.json';
import es from './es.json';
import ptBR from './pt-BR.json';

// Languages that appear in the switcher — controlled by REACT_APP_ENABLED_LANGUAGES
// Default: only English, so unreviewed translations are never shown to users.
const enabledRaw = process.env.REACT_APP_ENABLED_LANGUAGES ?? 'en';
export const ENABLED_LANGUAGES: string[] = enabledRaw.split(',').map(l => l.trim()).filter(Boolean);

export const LANGUAGE_NAMES: Record<string, string> = {
  en:    'English',
  fr:    'Français',
  de:    'Deutsch',
  es:    'Español',
  'pt-BR': 'Português (BR)',
};

rawI18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en:    { translation: en },
      fr:    { translation: fr },
      de:    { translation: de },
      es:    { translation: es },
      'pt-BR': { translation: ptBR },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'teh_language',
      caches: ['localStorage'],
    },
  });

// i18next v26 uses TS 5 conditional types that TS 4.9 cannot resolve — cast to a minimal interface.
interface I18nCompat {
  language: string;
  changeLanguage(lng: string): Promise<unknown>;
  on(event: string, cb: (lng: string) => void): void;
}
const i18n = rawI18n as unknown as I18nCompat;

// Sync language preference with the backend when it changes.
i18n.on('languageChanged', (lng) => {
  fetch('/api/settings/profile', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ preferredLanguage: lng }),
  }).catch(() => {});
});

export async function syncLanguageFromProfile(): Promise<void> {
  try {
    const res = await fetch('/api/settings/profile');
    if (!res.ok) return;
    const data: { preferredLanguage: string | null } = await res.json();
    if (data.preferredLanguage && data.preferredLanguage !== i18n.language) {
      await i18n.changeLanguage(data.preferredLanguage);
    }
  } catch {
    // Non-critical: fall back to detected language
  }
}

export default rawI18n;
